
<div class="sign-in-page">
    <div class="sign-in-container">
        <div class="signin-header-container">
             <img class="" src="../../../assets/images/world.jpeg" width="200">
            <span class="sign-in-header"></span>
        </div>
        <div class="sign-in-title-continer">
            <span>Password Reset</span>
        </div>
        <div class="d-flex justify-content-center"></div>

        <div class="login mt-3 px-2 py-2">
            <form [formGroup]="resetFG" autocomplete="off" >
                
                <mat-form-field  class="required col-md-12 form-group ">
                    <mat-label>Password</mat-label>
                    <div class="input-with-icon col-md-12">
                    <input matInput required type="password"  formControlName="password" id="passwordinput" name="password" autocomplete="new-password" aria-describedby="passwordHint" [type]="passwordType">
                    <mat-icon *ngIf="visibility_off" class="mright" (click)="togglePassword()">visibility</mat-icon>
                    <mat-icon *ngIf="!visibility_off" class="mright" (click)="togglePassword()">visibility_off</mat-icon>
                    </div>
                    <small *ngIf="resetFG.controls['password'].dirty && resetFG.controls['password'].invalid" class="warn">{{getControlErrMsg(resetFG.controls['password'])}}<br></small>
                    <small id="passwordHint">Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character</small>
                     </mat-form-field>
                  <mat-form-field  class="required col-md-12 form-group ">
                    <mat-label>Confirm Password</mat-label>
                    <div class="input-with-icon col-md-12">
                    <input matInput required type="password" id="confirmpasswordinput" formControlName="confirmPassword" name="confirmPassword" [type]="conpasswordType" autocomplete="new-password">
                    <mat-icon *ngIf="visibility_of" class="mright" (click)="toggleconfirmPassword()">visibility</mat-icon>
                    <mat-icon *ngIf="!visibility_of" class="mright" (click)="toggleconfirmPassword()">visibility_off</mat-icon>
                    </div>
                    <mat-error *ngIf="nameControl.errors">Password length from 8 to 30 characters.<br>
                      Combination of alphabet, digit and special character(@#$%!)<br>
                      Atleast 1 capital letter, 1 small letter, 1 digit and 1 special character.<br>
                      Start with alphabet.</mat-error>
                  </mat-form-field>
              
               
                <div class="login-submit-container mt-3">
                    <button type="submit" class="btn btn-success login-submit-btn" [disabled]="!resetFG.valid" (click)="resetPasswd()">Save</button>
                </div>
            </form>
            <div class="line mt-3"></div>
          
            <div class="line mt-3"></div>
        </div>
    </div>
</div>